require('element-matches-polyfill');

document.addEventListener("DOMContentLoaded", function() {

    /* Filter dropdown box - news and events archive page
    ---------------------------------------*/
    let filterDisplayButton = document.getElementById('filter-display-button');
    let filterBox = document.getElementById('filter-box');

    document.addEventListener('click', function (event) {

        // If the clicked element isn't the hamburger, return
        if (!event.target.matches('#filter-display-button')) return;

        if (filterDisplayButton.classList.contains('active')){
            filterDisplayButton.classList.remove('active');
        }else{
            filterDisplayButton.classList.add('active');
        }

        if (filterBox.classList.contains('hidden')){
            filterBox.classList.remove('hidden');
        }else{
            filterBox.classList.add('hidden');
        }

    }, false);

});
